import { officeOrderModalConstants } from "../actions/constants";

const initState = {
    open: false,
    orderId: "",
    officeId: "",
    activeTab: "overview",
    activePanel: "",
    source: "",
    sourceTitle: "",
    backPayload: null,
    payload: null,
    openedAt: null,
};

export default function officeOrderModalReducer(state = initState, action) {
    switch (action.type) {
        case officeOrderModalConstants.OFFICE_ORDER_MODAL_OPEN:
            return {
                ...state,
                open: true,
                orderId: action.payload?.orderId || "",
                officeId: action.payload?.officeId || "",
                activeTab: action.payload?.activeTab || "overview",
                activePanel: action.payload?.activePanel || "",
                source: action.payload?.source || "",
                sourceTitle: action.payload?.sourceTitle || "",
                backPayload: action.payload?.backPayload || null,
                payload: action.payload?.payload || null,
                openedAt: action.payload?.openedAt || Date.now(),
            };

        case officeOrderModalConstants.OFFICE_ORDER_MODAL_CLOSE:
            return {
                ...initState,
            };

        case officeOrderModalConstants.OFFICE_ORDER_MODAL_SET_TAB:
            return {
                ...state,
                activeTab: action.payload || "overview",
                activePanel: "",
            };

        case officeOrderModalConstants.OFFICE_ORDER_MODAL_SET_PANEL:
            return {
                ...state,
                activePanel: action.payload || "",
            };

        case officeOrderModalConstants.OFFICE_ORDER_MODAL_PATCH:
            return {
                ...state,
                ...(action.payload || {}),
            };

        default:
            return state;
    }
}